import { Accordion, MediumArrowIcon } from '../../../';

interface FilterItemProps {
	expandAll: boolean;
	defaultOpen?: boolean;
	filterTitle: string;
	activeLabel?: string;
	children: React.ReactNode;
	className?: string;
}

function FilterItem({ expandAll, filterTitle, activeLabel, children, ...props }: FilterItemProps) {
	return (
		<Accordion
			title={
				<div className="flex items-center text-base">
					{!!activeLabel && <div className="mr-2 rounded-full bg-blue w-2 h-2" />}
					{filterTitle}
					{!!activeLabel && <span className="text-xs ml-2 text-gray-400">- {activeLabel}</span>}
				</div>
			}
			closeOnNavigate
			open={expandAll}
			openIcon={MediumArrowIcon}
			closeIcon={MediumArrowIcon}
			openIconClass="fill-blue w-3 h-3 rotate-180 ml-0.5"
			closeIconClass="fill-blue w-3 h-3"
			{...props}
		>
			{children}
		</Accordion>
	);
}

export default FilterItem;
